import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('accessToken');
  const location = useLocation();

  if (!isAuthenticated) {
    const intendedPath = location.pathname;
    sessionStorage.setItem('intendedPath', intendedPath);
    return <Navigate to={`/login`} />;
  }

  return children;
};

export default ProtectedRoute;
